import styled from 'styled-components';
import { DatePicker } from '@src/components/elements';
export const DateSelector = styled(DatePicker) `
	max-width: 50%;
	flex: 1;
`;
